import {languagePackage} from "../../../common/language";

const VitalSignDetailSteps = [
    {
        selector: '.new-record',
        content: languagePackage().AddNewRecordTips,
    }
]

export {
    VitalSignDetailSteps
}
